/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdditionalRecruitmentInfoResponseDto,
  AdminContestDetailResponseDto,
  AdminContestListResponseDto,
  BibConfirmationPreviewResponseDto,
  BibConfirmationResultResponseDto,
  BibNumberUploadErrorResponseDto,
  BibNumberUploadResponseDto,
  ChangeContestStatusDto,
  ContestAdminControllerDeleteContestV1200,
  ContestAdminControllerDeleteCourseGpxV1200,
  ContestAdminControllerDownloadApplicantsExcelV1Params,
  ContestAdminControllerGetContestApplicantsV1Params,
  ContestAdminControllerGetContestParticipantStatsV1Params,
  ContestAdminControllerGetContestParticipantsV1Params,
  ContestAdminControllerGetContestRecordsV1Params,
  ContestAdminControllerGetContestsV1Params,
  ContestAdminControllerUploadBibNumbersV1Body,
  ContestAdminControllerUploadContestRecordsV1Body,
  ContestAdminControllerUploadCourseGpxV1200,
  ContestAdminControllerUploadCourseGpxV1Body,
  ContestCategoriesResponseDto,
  ContestDetailResponseDto,
  ContestDto,
  ContestParticipantStatsResponseDto,
  ContestRecordUploadResponseDto,
  ContestRecordsListResponseDto,
  CreateContestDto,
  FlattenedParticipantsResponseDto,
  SetAdditionalRecruitmentDto,
  UpdateContestDto
} from '../model';

import { axiosInstance } from '../../axiosInstance';




/**
 * @summary 대회 등록
 */
export const contestAdminControllerCreateContestV1 = (
    createContestDto: CreateContestDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestDetailResponseDto>(
      {url: `/v1/admin/contests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContestDto, signal
    },
      );
    }
  


export const getContestAdminControllerCreateContestV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>, TError,{data: CreateContestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>, TError,{data: CreateContestDto}, TContext> => {

const mutationKey = ['contestAdminControllerCreateContestV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>, {data: CreateContestDto}> = (props) => {
          const {data} = props ?? {};

          return  contestAdminControllerCreateContestV1(data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerCreateContestV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>>
    export type ContestAdminControllerCreateContestV1MutationBody = CreateContestDto
    export type ContestAdminControllerCreateContestV1MutationError = void

    /**
 * @summary 대회 등록
 */
export const useContestAdminControllerCreateContestV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>, TError,{data: CreateContestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerCreateContestV1>>,
        TError,
        {data: CreateContestDto},
        TContext
      > => {
      return useMutation(getContestAdminControllerCreateContestV1MutationOptions(options), queryClient);
    }
    /**
 * 대회 목록 조회
 * @summary 대회 목록 조회
 */
export const contestAdminControllerGetContestsV1 = (
    params?: ContestAdminControllerGetContestsV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<AdminContestListResponseDto>(
      {url: `/v1/admin/contests`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerGetContestsV1QueryKey = (params?: ContestAdminControllerGetContestsV1Params,) => {
    return [
    `/v1/admin/contests`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerGetContestsV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError = unknown>(params?: ContestAdminControllerGetContestsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestsV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>> = ({ signal }) => contestAdminControllerGetContestsV1(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>>
export type ContestAdminControllerGetContestsV1QueryError = unknown


export function useContestAdminControllerGetContestsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError = unknown>(
 params: undefined |  ContestAdminControllerGetContestsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 목록 조회
 */

export function useContestAdminControllerGetContestsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestsV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 대회 정보 수정
 * @summary 대회 수정
 */
export const contestAdminControllerUpdateContestV1 = (
    contestId: string,
    updateContestDto: UpdateContestDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestDetailResponseDto>(
      {url: `/v1/admin/contests/${contestId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContestDto, signal
    },
      );
    }
  


export const getContestAdminControllerUpdateContestV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>, TError,{contestId: string;data: UpdateContestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>, TError,{contestId: string;data: UpdateContestDto}, TContext> => {

const mutationKey = ['contestAdminControllerUpdateContestV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>, {contestId: string;data: UpdateContestDto}> = (props) => {
          const {contestId,data} = props ?? {};

          return  contestAdminControllerUpdateContestV1(contestId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerUpdateContestV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>>
    export type ContestAdminControllerUpdateContestV1MutationBody = UpdateContestDto
    export type ContestAdminControllerUpdateContestV1MutationError = void

    /**
 * @summary 대회 수정
 */
export const useContestAdminControllerUpdateContestV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>, TError,{contestId: string;data: UpdateContestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerUpdateContestV1>>,
        TError,
        {contestId: string;data: UpdateContestDto},
        TContext
      > => {
      return useMutation(getContestAdminControllerUpdateContestV1MutationOptions(options), queryClient);
    }
    /**
 * 대회를 삭제합니다. 예약 내역이 있는 경우 삭제할 수 없습니다.
 * @summary 대회 삭제
 */
export const contestAdminControllerDeleteContestV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestAdminControllerDeleteContestV1200>(
      {url: `/v1/admin/contests/${contestId}`, method: 'DELETE', signal
    },
      );
    }
  


export const getContestAdminControllerDeleteContestV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>, TError,{contestId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>, TError,{contestId: string}, TContext> => {

const mutationKey = ['contestAdminControllerDeleteContestV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>, {contestId: string}> = (props) => {
          const {contestId} = props ?? {};

          return  contestAdminControllerDeleteContestV1(contestId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerDeleteContestV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>>
    
    export type ContestAdminControllerDeleteContestV1MutationError = void

    /**
 * @summary 대회 삭제
 */
export const useContestAdminControllerDeleteContestV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>, TError,{contestId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerDeleteContestV1>>,
        TError,
        {contestId: string},
        TContext
      > => {
      return useMutation(getContestAdminControllerDeleteContestV1MutationOptions(options), queryClient);
    }
    /**
 * 대회 상세 정보 및 통계 조회 (신청자/참가자 명단은 별도 API 사용)
 * @summary 대회 상세 조회
 */
export const contestAdminControllerGetContestDetailV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<AdminContestDetailResponseDto>(
      {url: `/v1/admin/contests/${contestId}`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerGetContestDetailV1QueryKey = (contestId: string,) => {
    return [
    `/v1/admin/contests/${contestId}`
    ] as const;
    }

    
export const getContestAdminControllerGetContestDetailV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError = void>(contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestDetailV1QueryKey(contestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>> = ({ signal }) => contestAdminControllerGetContestDetailV1(contestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestDetailV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>>
export type ContestAdminControllerGetContestDetailV1QueryError = void


export function useContestAdminControllerGetContestDetailV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError = void>(
 contestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestDetailV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestDetailV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 상세 조회
 */

export function useContestAdminControllerGetContestDetailV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestDetailV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestDetailV1QueryOptions(contestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 대회 카테고리 전체 목록 조회
 * @summary 대회 카테고리 목록 조회
 */
export const contestAdminControllerGetCategoriesV1 = (
    
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestCategoriesResponseDto>(
      {url: `/v1/admin/contests/categories`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerGetCategoriesV1QueryKey = () => {
    return [
    `/v1/admin/contests/categories`
    ] as const;
    }

    
export const getContestAdminControllerGetCategoriesV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetCategoriesV1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>> = ({ signal }) => contestAdminControllerGetCategoriesV1(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetCategoriesV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>>
export type ContestAdminControllerGetCategoriesV1QueryError = unknown


export function useContestAdminControllerGetCategoriesV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetCategoriesV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetCategoriesV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 카테고리 목록 조회
 */

export function useContestAdminControllerGetCategoriesV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetCategoriesV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetCategoriesV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 종료된 대회(COMPLETED)의 기록 목록 조회
 * @summary 대회 기록 목록 조회
 */
export const contestAdminControllerGetContestRecordsV1 = (
    params?: ContestAdminControllerGetContestRecordsV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestRecordsListResponseDto>(
      {url: `/v1/admin/contests/records`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerGetContestRecordsV1QueryKey = (params?: ContestAdminControllerGetContestRecordsV1Params,) => {
    return [
    `/v1/admin/contests/records`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerGetContestRecordsV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError = unknown>(params?: ContestAdminControllerGetContestRecordsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestRecordsV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>> = ({ signal }) => contestAdminControllerGetContestRecordsV1(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestRecordsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>>
export type ContestAdminControllerGetContestRecordsV1QueryError = unknown


export function useContestAdminControllerGetContestRecordsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError = unknown>(
 params: undefined |  ContestAdminControllerGetContestRecordsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestRecordsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestRecordsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestRecordsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestRecordsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 기록 목록 조회
 */

export function useContestAdminControllerGetContestRecordsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestRecordsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestRecordsV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestRecordsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 각 대회별 총 신청자 수와 참가자 수(결제 완료) 조회
 * @summary 대회별 참가자 통계 조회
 */
export const contestAdminControllerGetContestParticipantStatsV1 = (
    params?: ContestAdminControllerGetContestParticipantStatsV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestParticipantStatsResponseDto>(
      {url: `/v1/admin/contests/participant-stats`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerGetContestParticipantStatsV1QueryKey = (params?: ContestAdminControllerGetContestParticipantStatsV1Params,) => {
    return [
    `/v1/admin/contests/participant-stats`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerGetContestParticipantStatsV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError = unknown>(params?: ContestAdminControllerGetContestParticipantStatsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestParticipantStatsV1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>> = ({ signal }) => contestAdminControllerGetContestParticipantStatsV1(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestParticipantStatsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>>
export type ContestAdminControllerGetContestParticipantStatsV1QueryError = unknown


export function useContestAdminControllerGetContestParticipantStatsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError = unknown>(
 params: undefined |  ContestAdminControllerGetContestParticipantStatsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestParticipantStatsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestParticipantStatsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestParticipantStatsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestParticipantStatsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회별 참가자 통계 조회
 */

export function useContestAdminControllerGetContestParticipantStatsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError = unknown>(
 params?: ContestAdminControllerGetContestParticipantStatsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantStatsV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestParticipantStatsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary 대회 상태 변경
 */
export const contestAdminControllerChangeContestStatusV1 = (
    contestId: string,
    changeContestStatusDto: ChangeContestStatusDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<void>(
      {url: `/v1/admin/contests/${contestId}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changeContestStatusDto, signal
    },
      );
    }
  


export const getContestAdminControllerChangeContestStatusV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>, TError,{contestId: string;data: ChangeContestStatusDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>, TError,{contestId: string;data: ChangeContestStatusDto}, TContext> => {

const mutationKey = ['contestAdminControllerChangeContestStatusV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>, {contestId: string;data: ChangeContestStatusDto}> = (props) => {
          const {contestId,data} = props ?? {};

          return  contestAdminControllerChangeContestStatusV1(contestId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerChangeContestStatusV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>>
    export type ContestAdminControllerChangeContestStatusV1MutationBody = ChangeContestStatusDto
    export type ContestAdminControllerChangeContestStatusV1MutationError = void

    /**
 * @summary 대회 상태 변경
 */
export const useContestAdminControllerChangeContestStatusV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>, TError,{contestId: string;data: ChangeContestStatusDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerChangeContestStatusV1>>,
        TError,
        {contestId: string;data: ChangeContestStatusDto},
        TContext
      > => {
      return useMutation(getContestAdminControllerChangeContestStatusV1MutationOptions(options), queryClient);
    }
    /**
 * 기본은 이름/전화번호 마스킹. 관리자가 마스킹 해제 권한(POST /admin/unmask)을 보유한 동안 자동으로 해제되어 반환됨
 * @summary 대회 신청자 목록 조회
 */
export const contestAdminControllerGetContestApplicantsV1 = (
    contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<FlattenedParticipantsResponseDto>(
      {url: `/v1/admin/contests/${contestId}/applicants`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerGetContestApplicantsV1QueryKey = (contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params,) => {
    return [
    `/v1/admin/contests/${contestId}/applicants`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerGetContestApplicantsV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError = void>(contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestApplicantsV1QueryKey(contestId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>> = ({ signal }) => contestAdminControllerGetContestApplicantsV1(contestId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestApplicantsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>>
export type ContestAdminControllerGetContestApplicantsV1QueryError = void


export function useContestAdminControllerGetContestApplicantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError = void>(
 contestId: string,
    params: undefined |  ContestAdminControllerGetContestApplicantsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestApplicantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestApplicantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 신청자 목록 조회
 */

export function useContestAdminControllerGetContestApplicantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestApplicantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestApplicantsV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestApplicantsV1QueryOptions(contestId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 기본은 이름/전화번호 마스킹. 관리자가 마스킹 해제 권한(POST /admin/unmask)을 보유한 동안 자동으로 해제되어 반환됨
 * @summary 대회 참가자 목록 조회
 */
export const contestAdminControllerGetContestParticipantsV1 = (
    contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<FlattenedParticipantsResponseDto>(
      {url: `/v1/admin/contests/${contestId}/participants`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerGetContestParticipantsV1QueryKey = (contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params,) => {
    return [
    `/v1/admin/contests/${contestId}/participants`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerGetContestParticipantsV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError = void>(contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetContestParticipantsV1QueryKey(contestId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>> = ({ signal }) => contestAdminControllerGetContestParticipantsV1(contestId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetContestParticipantsV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>>
export type ContestAdminControllerGetContestParticipantsV1QueryError = void


export function useContestAdminControllerGetContestParticipantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError = void>(
 contestId: string,
    params: undefined |  ContestAdminControllerGetContestParticipantsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestParticipantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetContestParticipantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 참가자 목록 조회
 */

export function useContestAdminControllerGetContestParticipantsV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerGetContestParticipantsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetContestParticipantsV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetContestParticipantsV1QueryOptions(contestId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 대회 신청자 목록 엑셀 파일 다운로드
 * @summary 대회 신청자 목록 엑셀 다운로드
 */
export const contestAdminControllerDownloadApplicantsExcelV1 = (
    contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<void>(
      {url: `/v1/admin/contests/${contestId}/applicants/excel`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getContestAdminControllerDownloadApplicantsExcelV1QueryKey = (contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params,) => {
    return [
    `/v1/admin/contests/${contestId}/applicants/excel`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getContestAdminControllerDownloadApplicantsExcelV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError = void>(contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerDownloadApplicantsExcelV1QueryKey(contestId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>> = ({ signal }) => contestAdminControllerDownloadApplicantsExcelV1(contestId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerDownloadApplicantsExcelV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>>
export type ContestAdminControllerDownloadApplicantsExcelV1QueryError = void


export function useContestAdminControllerDownloadApplicantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError = void>(
 contestId: string,
    params: undefined |  ContestAdminControllerDownloadApplicantsExcelV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadApplicantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadApplicantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 신청자 목록 엑셀 다운로드
 */

export function useContestAdminControllerDownloadApplicantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError = void>(
 contestId: string,
    params?: ContestAdminControllerDownloadApplicantsExcelV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadApplicantsExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerDownloadApplicantsExcelV1QueryOptions(contestId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 대회 참가자(결제 완료) 목록 엑셀 파일 다운로드
 * @summary 대회 참가자 목록 엑셀 다운로드
 */
export const contestAdminControllerDownloadParticipantsExcelV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<void>(
      {url: `/v1/admin/contests/${contestId}/participants/excel`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerDownloadParticipantsExcelV1QueryKey = (contestId: string,) => {
    return [
    `/v1/admin/contests/${contestId}/participants/excel`
    ] as const;
    }

    
export const getContestAdminControllerDownloadParticipantsExcelV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError = void>(contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerDownloadParticipantsExcelV1QueryKey(contestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>> = ({ signal }) => contestAdminControllerDownloadParticipantsExcelV1(contestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerDownloadParticipantsExcelV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>>
export type ContestAdminControllerDownloadParticipantsExcelV1QueryError = void


export function useContestAdminControllerDownloadParticipantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError = void>(
 contestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadParticipantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadParticipantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 참가자 목록 엑셀 다운로드
 */

export function useContestAdminControllerDownloadParticipantsExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadParticipantsExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerDownloadParticipantsExcelV1QueryOptions(contestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 코스별 시트로 참가 확정자(결제 완료) 목록을 배번호 순으로 출력한 기록 입력 템플릿을 다운로드합니다. 식별/표시 컬럼은 잠겨 있고 출발시각/완주시각/칩기록/CP1~CP20만 입력할 수 있습니다.
 * @summary 대회 기록 업로드용 엑셀 템플릿 다운로드
 */
export const contestAdminControllerDownloadRecordTemplateExcelV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<void>(
      {url: `/v1/admin/contests/${contestId}/records/excel`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerDownloadRecordTemplateExcelV1QueryKey = (contestId: string,) => {
    return [
    `/v1/admin/contests/${contestId}/records/excel`
    ] as const;
    }

    
export const getContestAdminControllerDownloadRecordTemplateExcelV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError = void>(contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerDownloadRecordTemplateExcelV1QueryKey(contestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>> = ({ signal }) => contestAdminControllerDownloadRecordTemplateExcelV1(contestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerDownloadRecordTemplateExcelV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>>
export type ContestAdminControllerDownloadRecordTemplateExcelV1QueryError = void


export function useContestAdminControllerDownloadRecordTemplateExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError = void>(
 contestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadRecordTemplateExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerDownloadRecordTemplateExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 대회 기록 업로드용 엑셀 템플릿 다운로드
 */

export function useContestAdminControllerDownloadRecordTemplateExcelV1<TData = Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerDownloadRecordTemplateExcelV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerDownloadRecordTemplateExcelV1QueryOptions(contestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 기록 템플릿 엑셀을 업로드하여 ContestRecord를 일괄 저장합니다. 칩기록 오름차순으로 코스별 전체/성별/카테고리 순위가 자동 계산되며, 완주시각 또는 칩기록이 없으면 미완주(DNF)로 처리됩니다. 검증 에러가 하나라도 있으면 전체가 저장되지 않고 errors 목록이 반환됩니다.
 * @summary 대회 기록 엑셀 업로드
 */
export const contestAdminControllerUploadContestRecordsV1 = (
    contestId: string,
    contestAdminControllerUploadContestRecordsV1Body: ContestAdminControllerUploadContestRecordsV1Body,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, contestAdminControllerUploadContestRecordsV1Body.file);

      return axiosInstance<ContestRecordUploadResponseDto>(
      {url: `/v1/admin/contests/${contestId}/records/upload`, method: 'POST',
       data: formData, signal
    },
      );
    }
  


export const getContestAdminControllerUploadContestRecordsV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>, TError,{contestId: string;data: ContestAdminControllerUploadContestRecordsV1Body}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>, TError,{contestId: string;data: ContestAdminControllerUploadContestRecordsV1Body}, TContext> => {

const mutationKey = ['contestAdminControllerUploadContestRecordsV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>, {contestId: string;data: ContestAdminControllerUploadContestRecordsV1Body}> = (props) => {
          const {contestId,data} = props ?? {};

          return  contestAdminControllerUploadContestRecordsV1(contestId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerUploadContestRecordsV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>>
    export type ContestAdminControllerUploadContestRecordsV1MutationBody = ContestAdminControllerUploadContestRecordsV1Body
    export type ContestAdminControllerUploadContestRecordsV1MutationError = void

    /**
 * @summary 대회 기록 엑셀 업로드
 */
export const useContestAdminControllerUploadContestRecordsV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>, TError,{contestId: string;data: ContestAdminControllerUploadContestRecordsV1Body}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerUploadContestRecordsV1>>,
        TError,
        {contestId: string;data: ContestAdminControllerUploadContestRecordsV1Body},
        TContext
      > => {
      return useMutation(getContestAdminControllerUploadContestRecordsV1MutationOptions(options), queryClient);
    }
    /**
 * 배번호가 확정된 대회는 수정할 수 없습니다(409). 참가자 엑셀 파일에서 배번호를 읽어 일괄 수정합니다. PAYMENT_CONFIRMED 상태인 참가자만 수정 가능하며, 모든 배번호가 입력되어 있어야 합니다. 중복 배번호나 빈 배번호가 있을 경우 전체 업로드가 실패합니다.
 * @summary 대회 배번호 일괄 수정
 */
export const contestAdminControllerUploadBibNumbersV1 = (
    contestId: string,
    contestAdminControllerUploadBibNumbersV1Body: ContestAdminControllerUploadBibNumbersV1Body,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, contestAdminControllerUploadBibNumbersV1Body.file);

      return axiosInstance<BibNumberUploadResponseDto>(
      {url: `/v1/admin/contests/${contestId}/bib-numbers/upload`, method: 'POST',
       data: formData, signal
    },
      );
    }
  


export const getContestAdminControllerUploadBibNumbersV1MutationOptions = <TError = BibNumberUploadErrorResponseDto | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>, TError,{contestId: string;data: ContestAdminControllerUploadBibNumbersV1Body}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>, TError,{contestId: string;data: ContestAdminControllerUploadBibNumbersV1Body}, TContext> => {

const mutationKey = ['contestAdminControllerUploadBibNumbersV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>, {contestId: string;data: ContestAdminControllerUploadBibNumbersV1Body}> = (props) => {
          const {contestId,data} = props ?? {};

          return  contestAdminControllerUploadBibNumbersV1(contestId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerUploadBibNumbersV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>>
    export type ContestAdminControllerUploadBibNumbersV1MutationBody = ContestAdminControllerUploadBibNumbersV1Body
    export type ContestAdminControllerUploadBibNumbersV1MutationError = BibNumberUploadErrorResponseDto | void

    /**
 * @summary 대회 배번호 일괄 수정
 */
export const useContestAdminControllerUploadBibNumbersV1 = <TError = BibNumberUploadErrorResponseDto | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>, TError,{contestId: string;data: ContestAdminControllerUploadBibNumbersV1Body}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerUploadBibNumbersV1>>,
        TError,
        {contestId: string;data: ContestAdminControllerUploadBibNumbersV1Body},
        TContext
      > => {
      return useMutation(getContestAdminControllerUploadBibNumbersV1MutationOptions(options), queryClient);
    }
    /**
 * 배번호 확정 시 발급될 QR 티켓 수와 배번호가 아직 할당되지 않은 참가자 목록을 조회합니다. 미할당 참가자가 있으면 확정이 차단되므로, 이 API로 사전에 확인해야 합니다.
 * @summary 배번호 확정 전 미리보기
 */
export const contestAdminControllerPreviewBibConfirmationV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<BibConfirmationPreviewResponseDto>(
      {url: `/v1/admin/contests/${contestId}/bib-confirmation/preview`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerPreviewBibConfirmationV1QueryKey = (contestId: string,) => {
    return [
    `/v1/admin/contests/${contestId}/bib-confirmation/preview`
    ] as const;
    }

    
export const getContestAdminControllerPreviewBibConfirmationV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError = void>(contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerPreviewBibConfirmationV1QueryKey(contestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>> = ({ signal }) => contestAdminControllerPreviewBibConfirmationV1(contestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerPreviewBibConfirmationV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>>
export type ContestAdminControllerPreviewBibConfirmationV1QueryError = void


export function useContestAdminControllerPreviewBibConfirmationV1<TData = Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError = void>(
 contestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerPreviewBibConfirmationV1<TData = Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerPreviewBibConfirmationV1<TData = Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 배번호 확정 전 미리보기
 */

export function useContestAdminControllerPreviewBibConfirmationV1<TData = Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerPreviewBibConfirmationV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerPreviewBibConfirmationV1QueryOptions(contestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 배번호를 확정하고 참가자(대표 + 단체 멤버) 전원의 QR 티켓을 일괄 발급합니다. 확정 후에는 배번호 일괄 수정(uploadBibNumbers)이 차단되며, 확정 해제는 불가능합니다. 대회 준비중(PREPARING) 또는 진행중(IN_PROGRESS) 상태일 때만 확정할 수 있으며(추가 모집 중에는 불가), 배번호가 할당되지 않은 참가자가 있으면 400으로 거부됩니다.
 * @summary 배번호 확정
 */
export const contestAdminControllerConfirmBibNumbersV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<BibConfirmationResultResponseDto>(
      {url: `/v1/admin/contests/${contestId}/bib-confirmation`, method: 'POST', signal
    },
      );
    }
  


export const getContestAdminControllerConfirmBibNumbersV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>, TError,{contestId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>, TError,{contestId: string}, TContext> => {

const mutationKey = ['contestAdminControllerConfirmBibNumbersV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>, {contestId: string}> = (props) => {
          const {contestId} = props ?? {};

          return  contestAdminControllerConfirmBibNumbersV1(contestId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerConfirmBibNumbersV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>>
    
    export type ContestAdminControllerConfirmBibNumbersV1MutationError = void

    /**
 * @summary 배번호 확정
 */
export const useContestAdminControllerConfirmBibNumbersV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>, TError,{contestId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerConfirmBibNumbersV1>>,
        TError,
        {contestId: string},
        TContext
      > => {
      return useMutation(getContestAdminControllerConfirmBibNumbersV1MutationOptions(options), queryClient);
    }
    /**
 * 대회 코스의 GPX 파일을 업로드합니다. GPX 파일은 지도 렌더링에 사용됩니다.
 * @summary 코스 GPX 파일 업로드
 */
export const contestAdminControllerUploadCourseGpxV1 = (
    contestId: string,
    courseId: string,
    contestAdminControllerUploadCourseGpxV1Body: ContestAdminControllerUploadCourseGpxV1Body,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`gpxFile`, contestAdminControllerUploadCourseGpxV1Body.gpxFile);
if(contestAdminControllerUploadCourseGpxV1Body.gpxDistance !== undefined) {
 formData.append(`gpxDistance`, contestAdminControllerUploadCourseGpxV1Body.gpxDistance.toString())
 }

      return axiosInstance<ContestAdminControllerUploadCourseGpxV1200>(
      {url: `/v1/admin/contests/${contestId}/courses/${courseId}/gpx`, method: 'POST',
       data: formData, signal
    },
      );
    }
  


export const getContestAdminControllerUploadCourseGpxV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>, TError,{contestId: string;courseId: string;data: ContestAdminControllerUploadCourseGpxV1Body}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>, TError,{contestId: string;courseId: string;data: ContestAdminControllerUploadCourseGpxV1Body}, TContext> => {

const mutationKey = ['contestAdminControllerUploadCourseGpxV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>, {contestId: string;courseId: string;data: ContestAdminControllerUploadCourseGpxV1Body}> = (props) => {
          const {contestId,courseId,data} = props ?? {};

          return  contestAdminControllerUploadCourseGpxV1(contestId,courseId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerUploadCourseGpxV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>>
    export type ContestAdminControllerUploadCourseGpxV1MutationBody = ContestAdminControllerUploadCourseGpxV1Body
    export type ContestAdminControllerUploadCourseGpxV1MutationError = void

    /**
 * @summary 코스 GPX 파일 업로드
 */
export const useContestAdminControllerUploadCourseGpxV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>, TError,{contestId: string;courseId: string;data: ContestAdminControllerUploadCourseGpxV1Body}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerUploadCourseGpxV1>>,
        TError,
        {contestId: string;courseId: string;data: ContestAdminControllerUploadCourseGpxV1Body},
        TContext
      > => {
      return useMutation(getContestAdminControllerUploadCourseGpxV1MutationOptions(options), queryClient);
    }
    /**
 * 대회 코스의 GPX 파일을 삭제합니다.
 * @summary 코스 GPX 파일 삭제
 */
export const contestAdminControllerDeleteCourseGpxV1 = (
    contestId: string,
    courseId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestAdminControllerDeleteCourseGpxV1200>(
      {url: `/v1/admin/contests/${contestId}/courses/${courseId}/gpx`, method: 'DELETE', signal
    },
      );
    }
  


export const getContestAdminControllerDeleteCourseGpxV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>, TError,{contestId: string;courseId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>, TError,{contestId: string;courseId: string}, TContext> => {

const mutationKey = ['contestAdminControllerDeleteCourseGpxV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>, {contestId: string;courseId: string}> = (props) => {
          const {contestId,courseId} = props ?? {};

          return  contestAdminControllerDeleteCourseGpxV1(contestId,courseId,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerDeleteCourseGpxV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>>
    
    export type ContestAdminControllerDeleteCourseGpxV1MutationError = void

    /**
 * @summary 코스 GPX 파일 삭제
 */
export const useContestAdminControllerDeleteCourseGpxV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>, TError,{contestId: string;courseId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerDeleteCourseGpxV1>>,
        TError,
        {contestId: string;courseId: string},
        TContext
      > => {
      return useMutation(getContestAdminControllerDeleteCourseGpxV1MutationOptions(options), queryClient);
    }
    /**
 * 대회의 추가 모집 설정 가능 여부, 현재 설정값, 코스별 잔여좌석 조회
 * @summary 추가 모집 설정 조회
 */
export const contestAdminControllerGetAdditionalRecruitmentInfoV1 = (
    contestId: string,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<AdditionalRecruitmentInfoResponseDto>(
      {url: `/v1/admin/contests/${contestId}/additional-recruitment`, method: 'GET', signal
    },
      );
    }
  



export const getContestAdminControllerGetAdditionalRecruitmentInfoV1QueryKey = (contestId: string,) => {
    return [
    `/v1/admin/contests/${contestId}/additional-recruitment`
    ] as const;
    }

    
export const getContestAdminControllerGetAdditionalRecruitmentInfoV1QueryOptions = <TData = Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError = void>(contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContestAdminControllerGetAdditionalRecruitmentInfoV1QueryKey(contestId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>> = ({ signal }) => contestAdminControllerGetAdditionalRecruitmentInfoV1(contestId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(contestId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContestAdminControllerGetAdditionalRecruitmentInfoV1QueryResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>>
export type ContestAdminControllerGetAdditionalRecruitmentInfoV1QueryError = void


export function useContestAdminControllerGetAdditionalRecruitmentInfoV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError = void>(
 contestId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetAdditionalRecruitmentInfoV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>,
          TError,
          Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContestAdminControllerGetAdditionalRecruitmentInfoV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 추가 모집 설정 조회
 */

export function useContestAdminControllerGetAdditionalRecruitmentInfoV1<TData = Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError = void>(
 contestId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contestAdminControllerGetAdditionalRecruitmentInfoV1>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContestAdminControllerGetAdditionalRecruitmentInfoV1QueryOptions(contestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * 대회의 추가 모집 기간과 종료 방식을 설정합니다. FCFS/LOTTERY 방식별 조건을 만족해야 하며, 추가 모집 예약도 배번호가 자동 할당됩니다. 추가 응모 종료일은 배번호 D-7 확정 시점 이전이어야 하고, 이미 배번호가 확정된 대회는 설정할 수 없습니다.
 * @summary 추가 모집 설정
 */
export const contestAdminControllerSetAdditionalRecruitmentV1 = (
    contestId: string,
    setAdditionalRecruitmentDto: SetAdditionalRecruitmentDto,
 signal?: AbortSignal
) => {
      
      
      return axiosInstance<ContestDto>(
      {url: `/v1/admin/contests/${contestId}/additional-recruitment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: setAdditionalRecruitmentDto, signal
    },
      );
    }
  


export const getContestAdminControllerSetAdditionalRecruitmentV1MutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>, TError,{contestId: string;data: SetAdditionalRecruitmentDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>, TError,{contestId: string;data: SetAdditionalRecruitmentDto}, TContext> => {

const mutationKey = ['contestAdminControllerSetAdditionalRecruitmentV1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>, {contestId: string;data: SetAdditionalRecruitmentDto}> = (props) => {
          const {contestId,data} = props ?? {};

          return  contestAdminControllerSetAdditionalRecruitmentV1(contestId,data,)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ContestAdminControllerSetAdditionalRecruitmentV1MutationResult = NonNullable<Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>>
    export type ContestAdminControllerSetAdditionalRecruitmentV1MutationBody = SetAdditionalRecruitmentDto
    export type ContestAdminControllerSetAdditionalRecruitmentV1MutationError = void

    /**
 * @summary 추가 모집 설정
 */
export const useContestAdminControllerSetAdditionalRecruitmentV1 = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>, TError,{contestId: string;data: SetAdditionalRecruitmentDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contestAdminControllerSetAdditionalRecruitmentV1>>,
        TError,
        {contestId: string;data: SetAdditionalRecruitmentDto},
        TContext
      > => {
      return useMutation(getContestAdminControllerSetAdditionalRecruitmentV1MutationOptions(options), queryClient);
    }
    